import 'magnific-popup'

export default {
	init() {

		const $loginModal = $('.login-modal-open')
		$loginModal.on('click', function() {
			openloginModal()
		})
		
		// Function to open the modal
		function openloginModal() {
			$.magnificPopup.open({
				items: {
					src: '#login-modal'
				},
				type: 'inline',
				preloader: false,
				modal: true,
				callbacks: {
                    close: function() {

					},
					open: function() {


					},
				}
			})
		}


        //Login modal input focus
        var modal_login = document.getElementById('login-modal')
        var form_login = $('form#login')

        // Open Modal on restricted page
        if(modal_login) {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString)

            if(urlParams.has('restricted')) {
				openloginModal();
            }
        }


        //Login Submit trigger
        form_login.on('submit', function(e){
            e.preventDefault()

            const login_status = $('form#login .login-status')
            let rememberme = 0

            if($('form#login #rememberme').is(':checked')){
                rememberme = 1
            }

            login_status.removeClass('success error').show().text('Pošiljam podatke uporabnika...')

            $.post(my_ajax_object.ajax_url, { action: 'ajaxlogin_nonce' }, function(nonce) {
                $.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: my_ajax_object.ajax_url,
                    data: {
                        'action': 'ajaxlogin',
                        'username': $('form#login #username').val(),
                        'password': $('form#login #password').val(),
                        'rememberme': rememberme,
                        'security': nonce
                    },
                    success: function(data){
                        login_status.text(data.message)
                        if(data.loggedin === true) {
                            login_status.addClass('success')
                            window.location.href = data.redirecturl
                        } else {
                            login_status.addClass('error')
                        }
                    }
                })
            })
		})
		

		/**
		Header user menu (avatar + spustni meni)
		Predloge: header-user-trigger.php, header-user-submenu.php; stili: _user-menu.scss
		*/
        const $userWrap = $(".logged-in-user-icon")
        const $userTrigger = $userWrap.find(".user-trigger")
        const $userMenu = $(".dashboard-submenu")

        const setUserMenu = (open) => {
            $userWrap.toggleClass("active", open)
            $userMenu.toggleClass("open", open)
            $userTrigger.attr("aria-expanded", open ? "true" : "false")
        }

        $userTrigger.on('click', function (e) {
            e.preventDefault()
            e.stopPropagation()
            setUserMenu(!$userMenu.hasClass("open"))
        })

        // Hover (naprave z miško): odpiranje je v CSS, tu samo uskladimo aria-expanded
        if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
            $userWrap.on('mouseenter', function () {
                $userTrigger.attr("aria-expanded", "true")
            })
            $userWrap.on('mouseleave', function () {
                $userTrigger.attr("aria-expanded", $userMenu.hasClass("open") ? "true" : "false")
            })
        }

        // Zapri ob kliku izven menija
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.logged-in-user-icon').length) {
                setUserMenu(false)
            }
        })

        // Zapri z Escape (fokus nazaj na gumb)
        $(document).on('keydown', function (e) {
            if (e.key === 'Escape' && $userMenu.hasClass('open')) {
                setUserMenu(false)
                $userTrigger.trigger('focus')
            }
        })

	}
}
